/*
* load
*/
$(window).on('load', function() {
	$('body').removeClass('js-preload');
});

/*
* header-menu
*/
$(function(){
	$('.js-toggle_button').on('click', function(){
		if(!$(this).hasClass('is-action')) {
			let scrollpos = $(window).scrollTop();
			$('body').addClass('is-fixed').css({'top': -scrollpos}).data('pos', scrollpos);
			$(this).addClass('is-action');
		} else {
			$('body').removeClass('is-fixed').css({'top': 0});
			window.scrollTo( 0 , $('body').data('pos') );
			$(this).removeClass('is-action');
		}

		if ($('.header_menu,.header_corp_menu').css('visibility') == 'hidden') {
			$('.header_menu,.header_corp_menu').addClass('is-action');
		} else {
			$('.header_menu,.header_corp_menu').removeClass('is-action');
		}
	});
	$('.header_menu a,.header_corp_menu a').on('click', function(){
		$('.js-toggle_button').click();
	});

	$('.header_icon_list_item.search').on('click', function(){
		if ($('.header_menu').css('visibility') == 'visible') {
			$('.header_menu').removeClass('is-action');
			$('body').removeClass('is-fixed').css({'top': 0});
			window.scrollTo( 0 , $('body').data('pos') );
			$('.js-toggle_button').removeClass('is-action');
		}
	});

	if (!window.schickHeaderSearchToggleBound) {
		var searchToggles = [
			{ button: '#header_icon_list_item_search',       panel: '#header_search' },
			{ button: '#header_icon_list_item_search-women', panel: '#header_search_women' }
		];
		$.each(searchToggles, function(i, toggle){
			$(toggle.button).on('click', function(){
				var $button = $(this);
				if ($button.hasClass('open')) {
					$(toggle.panel).fadeOut(300);
					$button.removeClass('open');
				} else {
					$('#header_menu').fadeOut(50);
					$('#header_menu_btn').removeClass('open');
					$(toggle.panel).fadeIn(200);
					$button.addClass('open');
				}
			});
		});
	}
});


/*
* scroll
 */
$(window).on('load' ,function(){
	var windowWidth = window.innerWidth ? window.innerWidth: $(window).width();
	if (windowWidth < 750) {
		var headerHeight = 60;
	} else {
		var headerHeight = 120;
	}
	var urlHash = location.hash;

	if(urlHash) {
		$('body,html').stop().scrollTop(0);
		setTimeout(function(){
			var target = $(urlHash);
			var position = target.offset().top - headerHeight;
			$('body,html').stop().animate({scrollTop:position}, 500);
		}, 100);
	}
	$('a[href*="#"]:not(.js-pagetop a)').click(function() {
		var target = $(this.hash);
		var position = target.offset().top - headerHeight;
		$('body,html').stop().animate({scrollTop:position}, 500);
		return false;
	});
});
if ($('.js-header_corp').length) {
	var header = $('.js-header_corp');
	$(window).scroll(function () {
		if ($(this).scrollTop() > 50) {
			header.addClass('is-white');
		} else {
			header.removeClass('is-white');
		}
	});
}

/*
* js-pagetop
*/
if ($('.js-pagetop').length) {
	$(document).ready(function(){
		$(window).on("scroll", function() {
			scrollHeight = $(document).height();
			scrollPosition = $(window).height() + $(window).scrollTop();
			footHeight = $(".footer").innerHeight();
			if ( scrollHeight - scrollPosition  <= footHeight - 70 ) {
				$('.js-pagetop').addClass('is-absolute');
			} else {
				$('.js-pagetop').removeClass('is-absolute');
			}
		});
	});
	$('.js-pagetop a').click(function () {
		var speed = 300;
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$('body,html').animate({
			scrollTop: position
		}, speed, 'swing');
		return false;
	});
}


/*
* js-slide
*/
if ($('.js-slide_mv').length) {
	$('.js-slide_mv').slick({
		autoplay: true,
		autoplaySpeed: 2500,
		speed: 800,
		slidesToShow: 1,
		swipe: true,
		arrows: false,
		dots: true,
		pauseOnFocus: false,
		pauseOnHover: false,
	});
}

if ($('.js-howto_box_slide').length) {
	$('.js-howto_box_slide').slick({
		autoplay: false,
		infinite: false,
		autoplaySpeed: 2500,
		speed: 800,
		slidesToShow: 2,
		arrows: true,
		dots: false,
		variableWidth: true,
		responsive: [{
			breakpoint: 751,
			settings: {
				slidesToShow: 1,

			}
		}]
	});
}

if ($('.js-safety_box_slide').length) {
	$('.js-safety_box_slide').slick({
		autoplay: true,
		autoplaySpeed: 2500,
		speed: 800,
		slidesToShow: 1,
		swipe: true,
		arrows: false,
		dots: true,
		pauseOnFocus: false,
		pauseOnHover: false,
	});
}

/*
* js-tab_panel
*/
if ($('.js-tab_panel').length) {
	const tabs = document.getElementsByClassName('js-tab');
	for(let i = 0; i < tabs.length; i++) {
		tabs[i].addEventListener('click', tabSwitch);
	}

	function tabSwitch(){
		const ancestorEle = this.closest('.js-tab_panel');
		ancestorEle.getElementsByClassName('is-active')[0].classList.remove('is-active');
		this.classList.add('is-active');
		ancestorEle.getElementsByClassName('is-show')[0].classList.remove('is-show');
		const groupTabs = ancestorEle.getElementsByClassName('js-tab');
		const arrayTabs = Array.prototype.slice.call(groupTabs);
		const index = arrayTabs.indexOf(this);
		ancestorEle.getElementsByClassName('js-panel')[index].classList.add('is-show');
	};
}

/*
* js-modal-video
*/
if ($(".js-modal_video").length) {
	$('.js-modal_video').magnificPopup({
		type: 'iframe',
		removalDelay: 200,
	});
}


/*
* js-tab_panel02
*/
if ($('.js-tab_panel02').length) {
	const tabs02 = document.getElementsByClassName('js-tab02');
	for(let i = 0; i < tabs02.length; i++) {
		tabs02[i].addEventListener('click', tabSwitch02);
	}

	function tabSwitch02(){
		const ancestorEle = this.closest('.js-tab_panel02');
		ancestorEle.getElementsByClassName('is-active02')[0].classList.remove('is-active02');
		this.classList.add('is-active02');
		ancestorEle.getElementsByClassName('is-show02')[0].classList.remove('is-show02');
		const groupTabs = ancestorEle.getElementsByClassName('js-tab02');
		const arrayTabs = Array.prototype.slice.call(groupTabs);
		const index = arrayTabs.indexOf(this);
		ancestorEle.getElementsByClassName('js-panel02')[index].classList.add('is-show02');
	};
}

const mvItems = document.querySelectorAll("[data-corp-mv-item]");
if (mvItems.length !== 0) {  // 要素が存在するか確認
	// CSSのカスタムプロパティを取得する関数
	function getCSSVariable(element, variable) {
		return getComputedStyle(element).getPropertyValue(variable);
	}

	const mvItemElement = document.querySelector(".corp_mv__item");

	// .corp_mv__itemが存在するか確認
	if (mvItemElement) {
		const duration = getCSSVariable(mvItemElement, "--duration");
		const delay = getCSSVariable(mvItemElement, "--delay");

		// 秒をミリ秒に変換
		const durationMs = parseFloat(duration) * 1000;
		const delayMs = parseFloat(delay) * 1000;

		// timings配列を動的に設定
		const timings = Array.from({ length: mvItems.length }, (_, i) => durationMs * (i + 1) - durationMs);

		// classActions配列を動的に生成
		const classActions = [];
		for (let i = 0; i < mvItems.length; i++) {
			classActions.push([i, (i + 1) % mvItems.length]);
		}

		function corpMv() {
			classActions.forEach((action, index) => {
				setTimeout(() => {
					mvItems.forEach((item) => {
						item.classList.remove("is-turn", "is-visible");
					});
					mvItems[action[0]].classList.add("is-turn");
					mvItems[action[1]].classList.add("is-visible");
				}, timings[index] + delayMs * (index));
			});
		}

		window.addEventListener("load", function () {
			setTimeout(() => {
				corpMv();
				setInterval(() => {
					corpMv();
				}, durationMs * mvItems.length + delayMs * mvItems.length);
			}, delayMs);
		});
	} 
}

/*
* css swicher
*/
function css_browser_selector(u){
	var ua=u.toLowerCase(),
		is=function(t){return ua.indexOf(t)>-1},
		e='edge',g='gecko',w='webkit',s='safari',o='opera',m='mobile',
		h=document.documentElement,
		b=[
			( !(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua))? ('ie ie'+RegExp.$1) :
				!(/opera|webtv/i.test(ua)) && is('trident') && /rv:(\d+)/.test(ua)? ('ie ie'+RegExp.$1) :
					is('edge/')? e:
						is('firefox/2')?g+' ff2':
							is('firefox/3.5')? g+' ff3 ff3_5' :
								is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')? g+' ff3' :
									is('gecko/')?g:
										is('opera')? o+(/version\/(\d+)/.test(ua)? ' '+o+RegExp.$1 :
											(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')) :
											is('konqueror')? 'konqueror' :
												is('blackberry')?m+' blackberry' :
													is('android')?m+' android' :
														is('chrome')?w+' chrome' :
															is('iron')?w+' iron' :
																is('applewebkit/')? w+' '+s+(/version\/(\d+)/.test(ua)? ' '+s+RegExp.$1 : '') :
																	is('mozilla/')? g:
																		'',
			is('j2me')?m+' j2me':
				is('iphone')?m+' iphone':
					is('ipod')?m+' ipod':
						is('ipad')?m+' ipad':
							is('mac')?'mac':
								is('darwin')?'mac':
									is('webtv')?'webtv':
										is('win')? 'win'+(is('windows nt 6.0')?' vista':''):
											is('freebsd')?'freebsd':
												(is('x11')||is('linux'))?'linux':
													'',
			'js'];
	c = b.join(' ');
	h.className += ' '+c;
	return c;
};
css_browser_selector(navigator.userAgent);

/*iPad判定 */
$(function(){
	var ua = window.navigator.userAgent.toLowerCase();
	if(ua.indexOf('ipad') > -1
		|| ua.indexOf('macintosh') > -1 && 'ontouchend' in document){
		$('html').addClass('ipad')
	}
});
